import { useEffect, useSyncExternalStore } from "react";

let meta = null;
const listeners = new Set();

export function setPageMeta(next) {
  meta = next;
  listeners.forEach((l) => l());
}

export function usePageMeta() {
  return useSyncExternalStore(
    (l) => { listeners.add(l); return () => listeners.delete(l); },
    () => meta,
    () => null,
  );
}

export function usePageMetaEffect(title, description) {
  useEffect(() => {
    if (title) setPageMeta({ title, description });
    return () => setPageMeta(null);
  }, [title, description]);
}
